import React from 'react';
import PropTypes from 'prop-types';

import LineTitleGray from './LineTitleGray';

const PlanDateTitle = (props) => {
  const { children, date } = props;
  return (
    <div className="PlanDateTitleContainer">
      <LineTitleGray>
        {children}
        <span className="PlanDateTitleDate">
          {date}
        </span>
      </LineTitleGray>
    </div>
  );
};

PlanDateTitle.defaultProps = {
};

PlanDateTitle.propTypes = {
  date: PropTypes.string,
  children: PropTypes.node,
};

export default PlanDateTitle;